import { Chart, LineController, LineElement, PointElement, LinearScale, CategoryScale, BarElement, BarController } from 'chart.js';
import { scales, color_rose, color_blue } from "./ChartConfig";
Chart.register(LineController, LineElement, PointElement, LinearScale, CategoryScale, BarElement, BarController);
export default function ThreeStatsChart(ctx, renderer) {
  var lastValidCompareIndex = -1;
  var timestamp = Date.now();
  var textureDataset = {
    label: 'texture count',
    data: [{
      x: 0,
      y: 0
    }],
    borderColor: color_rose,
    borderWidth: 1.5,
    pointRadius: 1
  };
  var geometryDataset = {
    label: 'geometry count',
    data: [{
      x: 0,
      y: 0
    }],
    borderColor: color_blue,
    borderWidth: 1.5,
    pointRadius: 1
  };
  var label = ['0s'];
  var chart = new Chart(ctx, {
    type: 'line',
    data: {
      labels: label,
      datasets: [textureDataset, geometryDataset]
    },
    options: {
      animation: {
        duration: 10
      },
      scales: scales
    }
  });
  this.update = function (displayed) {
    var limit = 60;
    var timeInS = Math.floor((Date.now() - timestamp) / 1000);
    var lbl = "".concat(timeInS, "s");
    var identical = lastValidCompareIndex > 0 && label[lastValidCompareIndex] == lbl;
    if (identical) {
      label.push('');
    } else {
      label.push(lbl);
      lastValidCompareIndex = label.length - 1;
    }
    if (label.length > limit) {
      label.shift();
      lastValidCompareIndex--;
    }
    var memory = renderer.info.memory;
    textureDataset.data.push({
      x: timeInS,
      y: memory.textures
    });
    geometryDataset.data.push({
      x: timeInS,
      y: memory.geometries
    });
    if (textureDataset.data.length > limit) {
      textureDataset.data.shift();
      geometryDataset.data.shift();
    }
    if (displayed) {
      chart.update();
    }
  };
  this.resize = function () {
    chart.resize();
  };
}